import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next';
import { pageTitle } from '../../helper'
import Cta from '../Cta'
import PageHeading from '../PageHeading'
import Div from '../Div'
import SectionHeading from '../SectionHeading'
import Spacing from '../Spacing'
import VideoModal from '../VideoModal'
import {portfolioData} from '../../data/portfolioData.js'
import Breadcrumbs from '../Breadcrumbs';
import { Helmet } from 'react-helmet';

export default function PortfolioDetailsPage() {
  const { t, i18n } = useTranslation();
  const isEn = i18n.language === 'en';
  const prefix = isEn ? '/en' : '';

  const params = useParams()
  const portfolioDetails = params.portfolioDetailsId
  ? portfolioData.find(item => item.id === params.portfolioDetailsId)
  : null;
  pageTitle(portfolioDetails.title);
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  return (
    <>
      <Helmet>
        <title>{portfolioDetails.title} — {portfolioDetails.subtitle} | Stable Records</title>
        <meta name="description" content={portfolioDetails.about ? portfolioDetails.about.substring(0, 155) + '...' : `Poslechněte si ${portfolioDetails.title} — projekt ze Stable Records nahrávacího studia u Prahy.`} />
      </Helmet>
      <PageHeading
        title={portfolioDetails.title + " - " + portfolioDetails.subtitle}
        bgSrc='/images/service_hero_bg.jpeg'
        pageLinkText={portfolioDetails.title}
        parentLinkText={t('portfolioDetail.breadcrumbPortfolio')}
        parentLink={'/portfolio'}
        style={{ color: 'red' }}
      />
      <Div className="container">
        <Breadcrumbs items={[
          { label: t('portfolioDetail.breadcrumbHome'), href: '/' },
          { label: t('portfolioDetail.breadcrumbPortfolio'), href: '/portfolio' },
          { label: portfolioDetails.title },
        ]} />
      </Div>
      <Spacing lg='150' md='80'/>
      <Div className="container">
        <VideoModal
          videoSrc={portfolioDetails.videoSrc}
          bgUrl={portfolioDetails.src}
        />
        <Spacing lg='90' md='40'/>
        <Div className="row">
          <Div className="col-lg-6">
            <SectionHeading
              title={portfolioDetails.title + " - " + portfolioDetails.subtitle}
              subtitle='Creative'
            >
              <Spacing lg='40' md='20'/>
              <p>{portfolioDetails.about}</p>
            </SectionHeading>
          </Div>
          <Div className="col-lg-5 offset-lg-1">
            <Spacing lg='60' md='40'/>
            <h2 className='cs-font_30 cs-font_26_sm cs-m0'>{t('portfolioDetail.projectInfo')}</h2>
            <Spacing lg='50' md='30'/>
            <Div className="row">
              <Div className="col-6">
                <h3 className='cs-accent_color cs-font_22 cs-font_18_sm cs-m0'>{t('portfolioDetail.production')}</h3>
                <p className='cs-m0'>{portfolioDetails.produkce}</p>
                <Spacing lg='30' md='30'/>
              </Div>
              <Div className="col-6">
                <h3 className='cs-accent_color cs-font_22 cs-font_18_sm cs-m0'>{t('portfolioDetail.mixMastering')}</h3>
                <p className='cs-m0'>{portfolioDetails.mix_mastering}</p>
                <Spacing lg='30' md='30'/>
              </Div>
              <Div className="col-6">
                <h3 className='cs-accent_color cs-font_22 cs-font_18_sm cs-m0'>{t('portfolioDetail.date')}</h3>
                <p className='cs-m0'>{portfolioDetails.released}</p>
                <Spacing lg='30' md='30'/>
              </Div>
              <Div className="col-6">
                <h3 className='cs-accent_color cs-font_22 cs-font_18_sm cs-m0'>{t('portfolioDetail.client')}</h3>
                <p className='cs-m0'>{portfolioDetails.client}</p>
                <Spacing lg='30' md='30'/>
              </Div>
            </Div>
          </Div>
        </Div>
      </Div>
      <Spacing lg='145' md='80'/>
      <Cta
        title='studio@stablerecords.cz'
        bgSrc='/images/cta_bg_2.jpeg'
        variant='rounded-0'
      />
    </>
  )
}